// extracted by mini-css-extract-plugin
module.exports = {"content":"_33e215d8","container":"_73ce2896","sticky":"_6b7e088e","cutoff":"_18ce4f1c","shadow":"_9b681d37"};